//@ts-check
import React from "react";
import { useAppDispatch } from "src/utils/ReduxHooks";
import useTypedSelector from "utils/useTypedSelector";
import LnIcon from "components/LnIcon";
import { imagePickerDuck } from "./ImagePickerDuck";
import { useI18n } from "components/lni18n";

/**
 * 
 * @param {{ className?: string, onSubmit: import("react").MouseEventHandler<HTMLButtonElement>, src: string }} props
 * @returns 
 */
const Preview = ({onSubmit, src, className}) => {

    const dispatch = useAppDispatch();
    const { languageService: t } = useI18n();
    const { imageAlign } = useTypedSelector(state => state.imagepicker);

    
    const setAlign = (align) => {
        dispatch(imagePickerDuck.setImageAlign(align));
    }

    return <div className={className}>




        <div className="d-flex justify-content-between flex-wrap">
            <div className="btn-group btn-group-toggle mb-3" data-toggle="buttons" >
                <button type="button" className={"btn btn-primary " + (imageAlign === "none" ? "active" : "")} onClick={() => setAlign('none')} >
                    <LnIcon name="noalign" className="filter-white" />
                </button>
                <button type="button" className={"btn btn-primary " + (imageAlign === "left" ? "active" : "")} onClick={() => setAlign('left')} >
                    <LnIcon name="leftalign" className="filter-white" />
                </button>
                <button type="button" className={"btn btn-primary " + (imageAlign === "right" ? "active" : "")} onClick={() => setAlign('right')} >
                    <LnIcon name="rightalign" className="filter-white" />
                </button>
            </div>

            <button onClick={onSubmit} className="mb-3 ml-3 btn btn-primary">{t.getText("ok")}</button>




        </div>

        <div className="mt-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse quis magna faucibus, elementum nisl vel, ullamcorper odio.
            Fusce pulvinar, ligula et ullamcorper luctus, magna erat tincidunt lectus, at congue augue leo ac dolor.
                <br />
            <img src={src} alt="" className={"m-3 " + (imageAlign !== 'none' ? "mw-75 " : "mw-100 ")
                + (imageAlign === 'left' ? "float-left " : "") + (imageAlign === 'right' ? "float-right " : "")} />

                    Nulla lacinia massa mi, vel efficitur quam consectetur sed. Suspendisse fermentum rhoncus pellentesque.
                    Maecenas aliquam arcu lectus,at malesuada neque viverra aliquam.
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse quis magna faucibus, elementum nisl vel, ullamcorper odio. Fusce pulvinar,
                    ligula et ullamcorper luctus, magna erat tincidunt lectus, at congue augue leo ac dolor.
                    Nulla lacinia massa mi, vel efficitur quam consectetur sed. Suspendisse fermentum rhoncus pellentesque.
                    Maecenas aliquam arcu lectus,at malesuada neque viverra aliquam.


            </div>

    </div>
}

export default Preview;
